import React from "react";
import Icon from "./icon";
import HTMLParser from "../../htmlParser";
const Coordinate = (props) => {
    const { className } = props?.attributes;
    const contentType = props?.attributes?.contentType || "a+tel:";
    const rawContent = props?.attributes?.content;
    const content = (["a+tel", "a+fax"].includes(contentType))
        ? rawContent.replaceAll(/( |\.)/gi, "")
        : rawContent;
    const Tag = contentType.includes("+")
        ? contentType.split("+")[0]
        : contentType;
    const linkType = contentType.split("+")[1];
    const linkProps = (Tag === "a")
        ? {
            href: linkType + content,
            title: "Nous contacter : " + rawContent
        }
        : {};
    return React.createElement("div", { className: className },
        props?.innerBlocks?.length
            ? React.createElement(Icon, { ...props?.innerBlocks[0] })
            : React.createElement(React.Fragment, null),
        React.createElement(Tag, { ...linkProps }, contentType === "p"
            ? React.createElement(HTMLParser, null, rawContent)
            : rawContent));
};
export default Coordinate;
